module.exports = __webpack_public_path__ + "img/v2.881f2172.png";